module.exports = __webpack_public_path__ + "static/img/logoysys.7fdfb24d.png";